import { RestMethod } from "../../_helpers/ApiConfig/RestMethod";
import FilterResponse, {
  FilterResponseV2,
} from "../../_helpers/FilterResponse";
const singleObj = "singleObj";
const version_type = 1;
const callApi = async (api, Method, data, type, objType) => {
  try {
    const response = await RestMethod[Method](api, data);
    if (type === version_type) {
      if (objType === singleObj) return response;
      const api_response = FilterResponse(response); //If respone 200 to 299 Then return
      return api_response.data;
    } else {
      const api_response = FilterResponseV2(response); //If respone 200 to 299 Then return
      return api_response.data[0]
        ? api_response.data[0]
        : objType === singleObj
        ? api_response
        : api_response.data;
    }
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
};

export const getAllBanksData = (payload) => {
  let params = "";
  Object.keys(payload).forEach((el, index) => {
    params +=
      index == 0
        ? `${[el] + "=" + payload[el]}`
        : "&" + `${[el] + "=" + payload[el]}`;
  });
  var reuestlink = `/blockchain/v1/bank${params ? `?${params}` : ``}`;
  return callApi(reuestlink, "GET", payload, version_type, singleObj);
};

export const getAllNodes = () => {
  var reuestlink = `/blockchain/v1/nodes`;
  return callApi(reuestlink, "GET", null, version_type, singleObj);
};

//5cfbb07f-3972-4f0b-8ddb-94c4c2b8c69d
export const getBlockchainHistoryData = (token) => {
  var reuestlink = `/blockchain/v1/token-audit-log/${token}`;
  return callApi(reuestlink, "GET");
};
